import { render, staticRenderFns } from "./CmgQrCode.vue?vue&type=template&id=1b3aea4d&scoped=true&lang=pug"
import script from "./cmg-qr-code.ts?vue&type=script&lang=ts&external"
export * from "./cmg-qr-code.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b3aea4d",
  null
  
)

export default component.exports